import { render, staticRenderFns } from "./comparison-table.vue?vue&type=template&id=30ea4142&scoped=true&"
import script from "./comparison-table.vue?vue&type=script&lang=ts&"
export * from "./comparison-table.vue?vue&type=script&lang=ts&"
import style0 from "./comparison-table.vue?vue&type=style&index=0&id=30ea4142&lang=scss&scoped=true&"
import style1 from "./comparison-table.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ea4142",
  null
  
)

export default component.exports